import React from 'react';

import { css } from '@emotion/react';
import { NeutralColorToken, Type } from '@robinhood/design';
import { MonthFullDate } from '@x1/util-format';
import moment from 'moment';
import QRCode from 'react-qr-code';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import { useGlobalStore } from 'src/state/global';

const DownloadAppPageDesktop = () => {
  const shippingMethod = useGlobalStore((s) => s.shippingMethod);
  const subtitle = React.useMemo(() => {
    if (shippingMethod == null) {
      return null;
    }
    const eta = shippingMethod?.eta != null ? MonthFullDate(moment(shippingMethod?.eta)) : null;
    const etaEnd = shippingMethod?.etaEnd != null ? MonthFullDate(moment(shippingMethod?.etaEnd)) : null;
    const etaString = eta && etaEnd ? `${eta} - ${etaEnd}` : eta || etaEnd || '';
    return (
      <>
        {etaString && (
          <>
            Your Gold Card arrives {etaString}
            <br />
          </>
        )}
        {shippingMethod?.carrier && <>Shipping via {shippingMethod?.carrier}</>}
      </>
    );
  }, [shippingMethod]);

  return (
    <CreditApplicationPageLayout title="There's Gold on the horizon" subtitle={subtitle}>
      <div css={root}>
        <QRCode
          bgColor={NeutralColorToken.Bg1}
          fgColor='#cfb97d' // SemanticColorToken.Positive doesn't work here
          value='https://robinhood.com/creditcard/download-app'
          size={200}
        />
        <div css={textContainer}>
          <Type.Display size='L' overrideRootStyles={{ fontWeight: 400 }}>
            Download the Robinhood Credit Card app to get your Gold Card
          </Type.Display>
          <Type.Text size='S'>
            Your Gold Card is ready to use immediately.
            <br />
            Get your card number in the app.
          </Type.Text>
        </div>
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;

const textContainer = css`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 16px;
`;

export default DownloadAppPageDesktop;
